import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import CustomerTimeline from './CustomerTimeline';
import CustomerTasksPanel from './CustomerTasksPanel';
import CustomerTagsPanel from './CustomerTagsPanel';
import CustomerLoyaltyPanel from './CustomerLoyaltyPanel';
import CustomerEmailComposer from './CustomerEmailComposer';

const TABS = [
  { id: 'timeline', label: 'TIMELINE' },
  { id: 'loyalty', label: 'LOYALTY' },
  { id: 'tasks', label: 'TASKS & REMINDERS' },
  { id: 'tags', label: 'TAGS' },
];

// The customer profile (timeline + stats) is fetched once at the modal level
// and passed in, so the Overview tab can render the stats without a duplicate
// call. Tasks and Tags tabs only need the user record.
export default function CustomerCrmPanel({ user, onUserSaved, profile, profileLoading, onNavigate, orders = [], onEmailSent }) {
  const [tab, setTab] = useState('timeline');
  const [showComposer, setShowComposer] = useState(false);

  const name = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.full_name || 'Customer';

  return (
    <div>
      <div className="flex items-start justify-between gap-4 mb-5">
        <div className="flex gap-1 border-b border-white/5 overflow-x-auto flex-1">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-4 py-2.5 text-[10px] font-bold tracking-wider transition-colors -mb-px border-b-2 whitespace-nowrap ${tab === t.id ? 'border-primary text-primary' : 'border-transparent text-white/40 hover:text-white'}`}>
              {t.label}
            </button>
          ))}
        </div>
        <button
          onClick={() => setShowComposer((s) => !s)}
          className={`inline-flex items-center gap-1.5 text-[10px] font-bold tracking-widest px-3 py-2 border transition-colors shrink-0 ${showComposer ? 'border-primary text-primary bg-primary/10' : 'border-white/10 text-white/50 hover:text-white hover:border-primary/50'}`}
        >
          <Mail className="w-3.5 h-3.5" /> SEND EMAIL
        </button>
      </div>

      {showComposer && (
        <div className="mb-6">
          <CustomerEmailComposer
            customerEmail={user.email}
            customerName={name}
            orders={orders}
            onClose={() => setShowComposer(false)}
            onSent={() => { setShowComposer(false); if (onEmailSent) onEmailSent(); }}
          />
        </div>
      )}

      {tab === 'timeline' && <CustomerTimeline timeline={profile?.timeline || []} loading={profileLoading} onNavigate={onNavigate} />}
      {tab === 'loyalty' && <CustomerLoyaltyPanel email={user.email} />}
      {tab === 'tasks' && <CustomerTasksPanel email={user.email} customerName={name} />}
      {tab === 'tags' && <CustomerTagsPanel user={user} onSaved={onUserSaved} />}
    </div>
  );
}